// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + ({"12":"profiler","526":"pages-DebugPage","777":"recorder"}[chunkId] || chunkId) + "-" + {"12":"0a971316d3d6a7059730","513":"300cc2e5f66500ce770a","526":"b5e7869415768197a996","777":"03fe3f4c34e0611d0b4b"}[chunkId] + ".js";
};